import { useCallback, useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import OrganizationSettings from "../OrganizationSettings/organizationSettings";
import { useDispatch } from "react-redux";
import Configurations from "../Configurations/configurations";
import DeckleMatchingData from "../DeckleMatching/deckleMatching";
import OrderEntryData from "../OrderEntry/orderEntry";
// import { useSelector } from "react-redux";
import LandingData from "../Landing/landing";
import ApproveDeckleData from "../approveDeckle/approveDeckle";
import ProductionPlanning from "../ProductionPlanning/productionPlanning";
import ProfileSetting from "../ProfileSettings/profileSettings";
import StockManagement from "../StockManagement/StockManagement";
import Login from "../Login/login";

const Home = (props) => {
  // const userRole = useSelector(({ loginReducer: { userRole } }) => userRole);
  // based on user role there should be conditional rendering
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateCallback = useCallback(
    (url = "") => {
      navigate(url, { replace: true });
    },
    [navigate]
  );
  useEffect(() => {
    async function fetchUserProfile() {
      try {
        //const userProfile = await getUserProfile();
        //localStorage.setItem('user-details', JSON.stringify(userProfile));
        // dispatch({
        //   type: ActionTypes.loginActions.SET_USER_PROFILE,
        //   data: userProfile,  
        // });
        const userProfile = JSON.parse(localStorage.getItem("user-details"));

        setRole(userProfile.role_type);
      } catch (error) {
        navigateCallback("/login");
      } finally {
      }
    }
    fetchUserProfile();
  }, [dispatch, navigateCallback]);
  useEffect(() => {
    switch (role) {
      case "ADMIN":
      // return navigateCallback("/organization-setting/");
      case "USER":
        return null;
      default:
        return null;
    }
  }, [role, navigateCallback]);

  return (
    <Routes>
      <Route index element={<Login />} />
      <Route
        path="/organization-setting/*"
        element={<OrganizationSettings />}
      />
      <Route path="/configuration/*" element={<Configurations />} />
      <Route path="/order-entry/*" element={<OrderEntryData />} />
      <Route path="/deckle-matching/*" element={<DeckleMatchingData />} />
      <Route path="/landing/" element={<LandingData />} />
      <Route path="/production-planning/*" element={<ProductionPlanning />} />
      <Route path="/profile-setting/*" element={<ProfileSetting />} />
      <Route path="/stock-management/*" element={<StockManagement />} />
    </Routes>
  );
};


export default Home;
